import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithTokenManagement from '../pages/auth/apiSlice';
import { usersApi } from 'api/user';
import { USER_TYPES } from '../constants';

export const authApi = createApi({
  tagTypes: ['User', 'Admin', 'AUTH'],
  reducerPath: 'authApi',
  baseQuery: baseQueryWithTokenManagement,
  endpoints: (builder) => ({
    authenticate: builder.mutation<any, void>({
      query: () => ({
        url: '/uaa/api/authenticate',
        method: 'post',
        body: {},
      }),
      transformResponse: (response: any) => {
        return response?.data;
      },
      onQueryStarted: async (arg, { queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          if (data?.id) {
            let storageUserIdentifier = 'userId';
            // Check if this is a warehouse context based on URL path
            if (window.location.pathname.includes('/warehouse')) {
              storageUserIdentifier = 'warehouse_userId';
            }
            localStorage.setItem(storageUserIdentifier, JSON.stringify(data.id));
          }
          // else {
          //   history.replaceState(null, '', ADMIN_ROUTES.adminSignIn);
          //   window.dispatchEvent(new PopStateEvent('popstate'));
          // }
        } catch (error) {
          console.error('Authentication failed:', error);
        }
      },
    }),
    adminSignIn: builder.mutation<any, any>({
      query: (data) => ({
        url: 'auth/admin',
        method: 'post',
        body: { ...data, loginType: USER_TYPES.REGULAR },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.id) {
            localStorage.setItem('userId', JSON.stringify(data.id));
            localStorage.setItem('application', JSON.stringify(USER_TYPES.REGULAR));
          }
          dispatch(usersApi.util.invalidateTags(['USER']));
        } catch (error) {
          console.error('Authentication failed:', error);
        }
      },
      invalidatesTags: () => ['User', 'Admin', 'AUTH'],
    }),
    adminPasswordReset: builder.mutation({
      query: (data) => ({
        url: '/uaa/api/forgot-password',
        method: 'post',
        body: data,
      }),
    }),
    adminCheckPasswordReset: builder.mutation({
      query: (data) => ({
        url: '/uaa/api/check-password-reset',
        method: 'post',
        body: data,
      }),
    }),
    adminFinishPasswordReset: builder.mutation({
      query: (data) => ({
        url: '/uaa/api/finish-password-reset',
        method: 'post',
        body: data,
      }),
    }),
    logout: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'post',
      }),
      invalidatesTags: () => ['User', 'Admin', 'AUTH'],
    }),
    adminUsers: builder.query<any, void>({
      query: () => ({
        url: '/uaa/api/all',
      }),
      transformResponse: (response: any) => {
        // Transform the response to the desired shape
        return response?.data?.map((item: any) => ({
          ...item,
          value: item.id,
          label: `${item.firstName} ${item.lastName}`,
        }));
      },
    }),
  }),
});

export const {
  useAdminSignInMutation,
  useAdminPasswordResetMutation,
  useAdminCheckPasswordResetMutation,
  useAdminFinishPasswordResetMutation,
  useAuthenticateMutation,
  useLogoutMutation,
  useAdminUsersQuery,
} = authApi;
